/* eslint-disable */
import { CircularProgress } from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import * as React from 'react'
import { useEffect } from 'react'
import { IoIosPause, IoIosPlay } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'

import {
  EnhancedTableToolbar,
  getComparator,
  stableSort
} from './stableSort.jsx'

import { Button } from 'react-bootstrap'
import ApiService from '../../../ApiService.js'
import {
  EMULATOR_URL,
  STOP_EMULATOR_URL,
  UPDATE_URL,
  USER_ASSIGN_EMULATOR_URL
} from '../../../constants.js'
import { useStates } from '../../../StateProvider.js'
import { useEmulatorStore } from '../../../stores/emulator/store.tsx'
import { GetEmulatorApi } from '../../api/emulator.js'
import { CustomTablePagination } from '../../CustomTablePagination.js'

export default function DataTable({
  handleAssignUserButtonClick,
  userAssingedEmulator,
  setUserAssingedEmulator,
  handleEmulatorTelephonePopup,
  emulatorEditedId,
  handleGeneratedIdButtonClick,
  emulatorData,
  updateSerial,
  handleCreateEmulator,
  row
}) {
  const { showToast } = useStates()
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('calories')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [refreshData, setRefreshData] = React.useState(false)
  const [stop, setStop] = React.useState(true)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)
  const [selectedColumn, setSelectedColumn] = React.useState(null)

  const [emulators, setEmulators] = React.useState([])

  const [emulatorDetails, setEmulatorDetails] = React.useState()
  const [playPause, setPlayPause] = React.useState(false)
  useEffect(() => {
    localStorage.setItem('playPause', JSON.stringify(playPause))
  }, [playPause])
  const [data, setData] = React.useState([])
  const [playedRows, setPlayedRows] = React.useState(() => {
    const storedData = localStorage.getItem('playedRows')
    return storedData ? JSON.parse(storedData) : {}
  })
  const totalEmulators = useEmulatorStore.getState().emulators
  const updateEmulators = useEmulatorStore((state) => state.updateEmulators)
  const navigate = useNavigate()
  const [selectedRow, setSelectedRow] = React.useState(
    localStorage.getItem('selectedRow') || null
  )

  // const handleColumnClick = (column) => {
  //   setSelectedColumn(column)
  //   console.log('column is pressed', column)

  //   navigate(`/gps_page_table/${ssid}`)
  // }

  const handlePlayPause = (ssid) => {
    setPlayedRows((prev) => {
      const updatedRows = { ...prev, [ssid]: true }
      localStorage.setItem('playedRows', JSON.stringify(updatedRows))
      return updatedRows
    })
    stopEmulator(ssid) // Stop emulator when pausing
  }

  React.useEffect(() => {
    setEmulators(emulatorData)
  }, [emulatorData])

  React.useEffect(() => {
    if (emulatorEditedId != null) {
      if (emulatorEditedId === 0) {
        fetchData()
      } else {
        refreshEditedEmulator(emulatorEditedId)
      }
    }
  }, [emulatorEditedId])

  React.useEffect(() => {
    const updateSerialEmu = async () => {
      const { success, data } = await GetEmulatorApi()
      if (success) {
        setEmulators(data)
      }
    }
    updateSerialEmu()
  }, [updateSerial])

  React.useEffect(() => {
    // GET Emulator with dynamic pagination
    const getAllEmulators = async () => {
      const token = localStorage.getItem('token')
      const { success, data, error } = await ApiService.makeApiCall(
        `${EMULATOR_URL}/list?page=${page + 1}&size=${rowsPerPage}`,
        'GET',
        null,
        token,
        null
      )

      if (success) {
        setData(data)
      } else {
        console.error('Error emulator', error)
      }
    }

    getAllEmulators()
  }, [refreshData, stop, page, rowsPerPage])

  const handleInputChange = (id, field, value) => {
    console.log('value is', value)

    const updatedData = data.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    )

    setData(updatedData)
  }

  const updateEmulator = async (ssid, trackingId, comment) => {
    const token = localStorage.getItem('token')
    const { success, data, error } = await ApiService.makeApiCall(
      `${UPDATE_URL}/${ssid}`,
      'PUT',
      {
        trackingId,
        comment
      },
      token,
      null
    )
    if (success) {
      setRefreshData(!refreshData)
      showToast('Emulator updated successfully', 'success')
    } else {
      console.error('Error emulator', error)
    }
  }
  // stop eEmulator()
  const stopEmulator = async (ssid) => {
    const token = localStorage.getItem('token')
    console.log('ssid', ssid)
    const { success, data, error } = await ApiService.makeApiCall(
      `${STOP_EMULATOR_URL}/${ssid}`,
      'PUT',
      null,
      token,
      null
    )
    if (success) {
      setStop(!stop)
      showToast('Emulator stop successfully', 'success')
    } else {
      console.error('Error stopping emulator:', error)
      showToast('Failed to stop emulator', 'error')
    }
  }
  
  // Fetch data from API
  const refreshEditedEmulator = async (emulatorEditedId) => {
    const token = localStorage.getItem('token')
    const { success, data, error } = await ApiService.makeApiCall(
      EMULATOR_URL,
      'GET',
      null,
      token,
      emulatorEditedId
    )
    if (success) {
      const updatedData = emulators.map((item) => {
        if (item.id === data.id) {
          return data
        }
        return item
      })
      // showToast('Updated Emulator table!', 'success')
      setEmulators(updatedData)
    } else {
      showToast('Failed to update Emulator table' + error, 'error')
      return { success: false, error: 'Failed to unassign user' }
    }
  }

  React.useEffect(() => {
    if (userAssingedEmulator != null) {
      const updatedData = emulators.map((item) => {
        if (item.id === userAssingedEmulator.id) {
          return { ...item, user: userAssingedEmulator.user }
        }
        return item
      })
      setEmulators(updatedData)
    }
  }, [userAssingedEmulator])

  // assign/unassign button
  const handleAssignButtonClick = async (row) => {
    if (row.user != null) {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(USER_ASSIGN_EMULATOR_URL + '/' + row.id, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })

        if (!response.ok || response.status !== 200) {
          showToast('Failed to unassign user', 'error')
          return { success: false, error: 'Failed to unassign user' }
        }
        // Send the removed user ID to refresh in user table
        const userAssignedEmulator = {
          user: {
            id: row.user?.id
          }
        }
        setUserAssingedEmulator(userAssignedEmulator)
        const updatedData = emulators.map((item) => {
          if (item.id === row.id) {
            return { ...item, user: null }
          }
          return item
        })
        showToast('User Un-Assigned', 'success')
        useEmulatorStore.getState().updateEmulators(updatedData)
        setEmulators(updatedData)
      } catch (error) {
        showToast(`Failed to unassign user ${error}`, 'error')
      }
    } else {
      handleAssignUserButtonClick(row)
    }
  }

  React.useEffect(() => {
    const unsubscribe = useEmulatorStore.subscribe(
      (newEmulators) => setEmulators(newEmulators.emulators),
      (state) => state.emulators
    )
    return () => unsubscribe()
  }, [])

  // Fetch data from API // GET  API
  const fetchData = async () => {
    setLoading(true)
    const { success, data, error } = await GetEmulatorApi()

    if (success) {
      console.log('emu data', data)
      setEmulators(data)
      updateEmulators(data)
      setLoading(false)
    } else {
      setError(error)
      setLoading(false)
    }
  }

  React.useEffect(() => {
    setLoading(true)
    const { success, error } = fetchData()
    if (success) {
      showToast('Fetched Emulators successfully', 'success')
    } else {
      showToast(error, 'error')
    }
  }, [])

  React.useEffect(() => {
    if (userAssingedEmulator != null) {
      const updatedData = emulators.map((item) => {
        if (item.id === userAssingedEmulator.id) {
          return { ...item, user: userAssingedEmulator.user }
        }
        return item
      })
      setEmulators(updatedData)
      // showToast('Updated emulator table!', 'success')
    }
  }, [userAssingedEmulator])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - emulators.length) : 0

  const visibleRows = React.useMemo(
    () =>
      stableSort(totalEmulators, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, emulators, rowsPerPage]
  )

  if (error) {
    return (
      <>
        <div className="error">
          <h1>Something went wrong!</h1>
          <p>Error: {error}</p>
          <EnhancedTableToolbar handleOpen={handleCreateEmulator} />
        </div>
      </>
    )
  }

  const handleNavigateToGps = (ssid) => {
    localStorage.setItem('selectedRow', ssid)
    setLoading(true)
    navigate('/gps', { state: { ssid: ssid } })
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', marginBottom: 0 }}>
        <EnhancedTableToolbar handleOpen={handleCreateEmulator} />
        <TableContainer
          sx={{
            overflowX: 'auto',
            '&::-webkit-scrollbar': { height: '10px' },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#fffff',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#2C6FEB',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#2C6FEB' }
          }}
        >
          {loading ? (
            <div
              style={{
                textAlign: 'center',
                marginTop: '20vh',
                marginBottom: '20vh'
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="small"
              className="main-emulator-table"
            >
              <TableHead className="main-table-header">
                <TableRow>
                  {[
                    'Id',
                    'Name',
                    'Truck',
                    'Trailer',
                    'Software',
                    'Tracking ID',
                    'Comments',
                    '',
                    ''
                  ].map((header) => (
                    <TableCell
                      key={header}
                      // onClick={() => handleColumnClick(header)} // ✅ Store clicked column
                      style={{
                        cursor: 'pointer',
                        backgroundColor:
                          selectedColumn === header ? '#cce5ff' : 'white'
                      }}
                      className="table-header"
                      sx={
                        header === 'Action'
                          ? {
                              width: '80px',
                              minWidth: '80px',
                              textAlign: 'center',
                              fontFamily: '"Poppins", sans-serif !important',
                              fontWeight: '600 !important',
                              fontSize: '18px',
                              letterSpacing: '0rem'
                            }
                          : {
                              fontFamily: '"Poppins", sans-serif !important',
                              fontWeight: '600 !important',
                              fontSize: '18px',
                              letterSpacing: '0rem'
                            }
                      }
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => {
                  const assigned = row.user !== null
                  // const isSelected = selectedRowId === row.ssid
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={row.id}
                      onClick={() => handleNavigateToGps(row?.ssid)}
                      sx={{
                        userSelect: 'none',
                        WebkitTapHighlightColor: 'transparent',
                        cursor: 'pointer',
                        backgroundColor: selectedRow === row?.ssid ? '#f5f5f5' : 'inherit',
                        transition: 'background-color 0.3s ease',
                        '&:hover': {
                          backgroundColor: selectedRow === row?.ssid ? '#f5f5f5' : '#f9f9f9'
                        }
                      }}
                    >
                      <TableCell className="table-cell table-id-font-alignment">
                        {page * rowsPerPage + index + 1}
                      </TableCell>

                      {/* Name */}
                      <TableCell className="table-cell">
                        <div
                          style={{
                            maxWidth: '150px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                          className="emulator-table-content-font"
                        >
                          {row.name || 'N/A'}
                        </div>
                      </TableCell>

                      {/* Truck */}
                      <TableCell className="table-cell">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div
                            style={{
                              maxWidth: '150px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                            className="emulator-table-content-font"
                          >
                            {row.truck || 'N/A'}
                          </div>
                        </div>
                      </TableCell>

                      {/* Trailer */}
                      <TableCell className="table-cell emulator-table-content-font">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div
                            style={{
                              maxWidth: '150px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                            className="emulator-table-content-font"
                          >
                            {row.trailer || 'N/A'}
                          </div>
                        </div>
                      </TableCell>

                      {/* Software */}
                      <TableCell className="table-cell emulator-table-content-font">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div
                            style={{
                              maxWidth: '150px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                            className="emulator-table-content-font"
                          >
                            {row.software || 'N/A'}
                          </div>
                        </div>
                      </TableCell>

                      {/* Tracking Id */}
                      <TableCell className="table-cell emulator-table-content-font">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input
                            type="text"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: 'white',
                              border:
                                '0.3px solid rgba(163, 163, 163, 0.3490196078)',
                              borderRadius: '5px',
                              height: '5vh',
                              marginLeft: '0',
                              fontWeight: 'lighter',
                              fontSize: '14px',
                              padding: '10px 15px',
                              // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                              transition: 'all 0.3s ease-in-out'
                            }}
                            value={row.trackingId || ''}
                            onClick={(e) => {
                              e.stopPropagation()
                            }}
                            onChange={(e) => {
                              e.stopPropagation()
                              handleInputChange(
                                row.id,
                                'trackingId',
                                e.target.value
                              )
                            }}
                            placeholder=""
                          />
                        </div>
                      </TableCell>

                      {/* Comments */}
                      <TableCell className="table-cell emulator-table-content-font">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input
                            type="text"
                            style={{
                              display: 'flex ',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: 'white',
                              border:
                                '0.3px solid rgba(163, 163, 163, 0.3490196078)',
                              borderRadius: '5px',
                              height: '5vh',
                              marginLeft: '0',
                              fontWeight: 'lighter',
                              fontSize: '14px',
                              padding: '10px 15px',
                              // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                              transition: 'all 0.3s ease-in-out'
                            }}
                            value={row.comment || ''}
                            onClick={(e) => {
                              e.stopPropagation()
                            }}
                            onChange={(e) => {
                              e.stopPropagation()
                              handleInputChange(
                                row.id,
                                'comment',
                                e.target.value
                              )
                            }}
                            placeholder=""
                          />
                        </div>
                      </TableCell>

                      {/* Save Button */}
                      <TableCell className="table-cell emulator-table-content-font">
                        <Button
                          style={{
                            backgroundColor: '#00C72E',
                            color: '#ffff',
                            border: 'none',
                            width: '97px',
                            height: '38px',
                            borderRadius: '4px'
                          }}
                          className="global-font py-2 fw-medium ms-0 mb-3"
                          onClick={(e) => {
                            e.stopPropagation()
                            updateEmulator(
                              row.ssid,
                              row.trackingId,
                              row.comment
                            )
                          }}
                        >
                          Save
                        </Button>
                      </TableCell>

                      <TableCell className="table-cell emulator-table-content-font">
                        {!playedRows[row.ssid] ? (
                          <span
                            onClick={(e) => {
                              e.stopPropagation()
                              handlePlayPause(row.ssid)
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <IoIosPause />
                          </span>
                        ) : (
                          <span style={{ opacity: 0.5 }}>
                            <IoIosPlay />
                          </span>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Paper>
      <div className="alignPagination">
        <CustomTablePagination
          rowsPerPageOptions={[10, 30, 50]}
          count={emulators.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="" // Removes "Rows per page:
          style={{ overflow: 'hidden' }}
        />
      </div>
    </Box>
  )
}
